import { type ZAFClient } from "./interface";
import { type ZendeskMacro } from "@interfaces/Macro";
export const zafClient = (window as Window).zafClient;

declare global {
  interface Window {
    zafClient: ZAFClient;
    initializedClient: {
      _origin: string;
    };
  }
}

export const getZendeskUrl = () => {
  const zendeskUrl =
    (window.location.ancestorOrigins === undefined
      ? (window as Window).initializedClient._origin
      : window.location.ancestorOrigins[0]) || "";

  return zendeskUrl;
};

export const isProduction = () => getZendeskUrl().includes("atendimento-britania.zendesk.com");

export const getCurrentTicketId = async (): Promise<string> => {
  const response = await zafClient.get("ticket.id");
  return response["ticket.id"];
};

export const getCurrentTicketType = async (): Promise<string> => {
  const response = await zafClient.get("ticket.type");
  return response["ticket.type"] as string;
};

const MACRO_ID = {
  production: 40952856032020,
  sandbox: 45752201531156,
};

export const showMacroContent = async (): Promise<ZendeskMacro> => {
  const macroId = isProduction() ? MACRO_ID.production : MACRO_ID.sandbox;
  const response = await zafClient.request({
    url: `/api/v2/macros/${macroId}`,
    type: "GET",
    contentType: "application/json",
  });

  return (response as { macro: ZendeskMacro }).macro;
};

export const getTicketFieldValue = async (fieldId: number): Promise<string> => {
  const fieldName = `custom_field_${fieldId}`;
  const response = await zafClient.get(`ticket.customField:${fieldName}`);
  return response[`ticket.customField:${fieldName}`] as string;
};

export const getCurrentRequesterEmail = async (): Promise<string> => {
  const response = await zafClient.get("ticket.requester.email");
  return response["ticket.requester.email"] as string;
};

export const getCurrentRequesterCpf = async (): Promise<string | null> => {
  try {
    const { "ticket.requester.id": requesterId } = await zafClient.get("ticket.requester.id");

    if (!requesterId) return null;

    const res = (await zafClient.request({
      url: `/api/v2/users/${requesterId}.json`,
      type: "GET",
    })) as { user?: { user_fields?: { cpf_3?: string } } };

    return res?.user?.user_fields?.cpf_3 ?? null;
  } catch (err) {
    console.warn("Erro ao buscar CPF do requester", err);
    return null;
  }
};
export const getCurrentRequesterName = async (): Promise<string> => {
  const response = await zafClient.get("ticket.requester.name");
  return response["ticket.requester.name"] as string;
};

export const popupError = (string: string, sticky: boolean) => {
  zafClient.invoke("notify", string, "error", { sticky });
};

export const popupSuccess = (string: string, sticky: boolean) => {
  zafClient.invoke("notify", string, "success", { sticky });
};

export const popupWarning = (message: string, sticky: boolean) => {
  zafClient.invoke("notify", message, "alert", { sticky });
};

export const showTicket = (ticketId: string) => {
  zafClient.invoke("routeTo", "ticket", { id: ticketId });
};

interface ProdutoRecord {
  id: string;
  name: string;
  custom_object_fields: Record<string, any>;
}

export const getProdutoFromTicket = async (fieldId: number): Promise<ProdutoRecord | null> => {
  const fieldName = `custom_field_${fieldId}`;
  const fieldResp = await zafClient.get(`ticket.customField:${fieldName}`);
  const lookupRecordId = fieldResp[`ticket.customField:${fieldName}`] as string | null;

  if (!lookupRecordId) {
    return null;
  }

  const objResp = await zafClient.request({
    url: `/api/v2/custom_objects/produto/records/${lookupRecordId}`,
    type: "GET",
    contentType: "application/json",
  });

  const rec = (objResp as any).custom_object_record;
  if (!rec) {
    return null;
  }

  const produto: ProdutoRecord = {
    id: rec.id,
    name: rec.name,
    custom_object_fields: rec.custom_object_fields,
  };

  return produto;
};
